/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Law_P1_BeforeInputs */

const es_landing_law_p1_before = /** @type {(inputs: Landing_Law_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde agosto de 2025, los armadores de embarcaciones de recreo privadas —`)
};

const gl_landing_law_p1_before = /** @type {(inputs: Landing_Law_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde agosto de 2025, os armadores de embarcacións de recreo privadas —`)
};

const en_landing_law_p1_before = /** @type {(inputs: Landing_Law_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From August 2025, owners of private recreational vessels —`)
};

/**
* | output |
* | --- |
* | "From August 2025, owners of private recreational vessels —" |
*
* @param {Landing_Law_P1_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_law_p1_before = /** @type {((inputs?: Landing_Law_P1_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Law_P1_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_law_p1_before(inputs)
	if (locale === "en") return en_landing_law_p1_before(inputs)
	return es_landing_law_p1_before(inputs)
});